var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vodal',{attrs:{"show":_vm.vodalVisible,"animation":"slideRight","closeButton":true,"closeOnEsc":true,"height":160},on:{"hide":() => _vm.vodalVisible = false}},[(_vm.vodalHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.vodalHtml)}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.vodalText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }